<template>
  <div>
    <div class="person-wrapper">
      <div class="person-offer-info">
        <div class="person-div-img">
          <img :src="this.getImagePath() + 'users/user_' + this.person.id + '.png'"
            @error="($event.target.src = require('@/assets/images/offer_0.svg'))" @click="selectPerson" />
        </div>
        <p class="p-small" v-html="
          $t('userOffers', {
            offers: person.offers_no,
            trainings: person.trainings_no,
            events: person.events_no,
          })
        "></p>
      </div>
      <person-contact :person="person" @addFriend="addFriend" v-if="!admin" :isFriend="isFriend"/>
      <p class="p-small">
        {{
  person.open_bussiness
    ? $t("openBussinessYes")
    : $t("openBussinessNo")
        }}
      </p>
    </div>
  </div>
</template>

<script>
import PersonContact from "./PersonContact.vue";

export default {
  name: "FriendCase",
  components: {
    PersonContact,
  },
  props: {
    person: Object,
    admin: Boolean,
    isFriend:Boolean
  },
  data() {
    return {
      // offer: null,
    };
  },
  methods: {
    addFriend() {
      this.$emit("addFriend", this.person.id);
    },
    selectPerson() {
      this.$emit("selectPerson", this.person);
    },
  },
};
</script>
<style scoped src="@/assets/styles/beneficiary.css">

</style>
<style scoped>
.person-wrapper {
  box-sizing: border-box;
  max-width: 262px;
  min-width: 235px;
  height: 300px;
  background: #ffffff;
  border: 1px solid #dedede;
  padding: 15px;
  display: flex;
  flex-wrap: wrap;
  margin-right: 20px;
  margin-top: 0px;
  margin-bottom: 20px;
}

.person-div-img {
  min-height: 64px;
  display: block;
}
</style>
